import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetSelfGoalSummariesRequestDto } from '../../dtos/goals/get-self-goal-summaries.request.dto';
import { GetSelfGoalSummariesResponseDto } from '../../dtos/goals/get-self-goal-summaries.response.dto';
import { GoalDto } from '../../../common/dto/goal.dto';
import { AppGoalsCubeMetric } from '../../../common/enum/goal/app-goals-cube-metrics.enum';
import { CoreScoreNames } from '../../../common/enum/scores/core-score-name.enum';
import { GetSelfScreentimeScoreGoalQuery } from '../../queries/goals/get-self-screentime-score-goal.query';
import { GetSelfDigitalIntensityScoreGoalQuery } from '../../queries/goals/get-self-digital-intensity-score-goal.query';
import { GetSelfFocusScoreGoalQuery } from '../../queries/goals/get-self-focus-score-goal.query';
import { GetSelfTimeInCallsScoreGoalQuery } from '../../queries/goals/get-self-time-in-calls-score.query';
import { GetSelfDigitalWorkingHoursScoreGoalQuery } from '../../queries/goals/get-self-digital-working-hours.query';
import { GetSelfTimeInAppGoalQuery } from '../../queries/goals/get-self-time-in-app-goal.query';
import { GetSelfInteractionsGoalQuery } from '../../queries/goals/get-self-interactions-goal.query';
import { GetSelfCallTimeInAppGoalQuery } from '../../queries/goals/get-self-call-time-in-app-goal.query';
import { GetSelfCalendarTimeInAppGoalQuery } from '../../queries/goals/get-self-calendar-time-in-app.query';
import { GetSelfGoalSummaryPresenter } from '../../presenters/goals/get-self-goal-summary.presenter';
import { GetSelfTimeInMeetingsScoreGoalQuery } from '../../queries/goals/get-self-time-in-meetings-score-goal.query';

export class GetSelfGoalSummariesCompositeController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly getSelfCalendarTimeInAppGoalQuery: GetSelfCalendarTimeInAppGoalQuery,
    protected readonly getSelfCallTimeInAppGoalQuery: GetSelfCallTimeInAppGoalQuery,
    protected readonly getSelfDigitalIntensityScoreGoalQuery: GetSelfDigitalIntensityScoreGoalQuery,
    protected readonly getSelfDigitalWorkingHoursScoreGoalQuery: GetSelfDigitalWorkingHoursScoreGoalQuery,
    protected readonly getSelfFocusScoreGoalQuery: GetSelfFocusScoreGoalQuery,
    protected readonly getSelfInteractionsGoalQuery: GetSelfInteractionsGoalQuery,
    protected readonly getSelfScreentimeScoreGoalQuery: GetSelfScreentimeScoreGoalQuery,
    protected readonly getSelfTimeInAppGoalQuery: GetSelfTimeInAppGoalQuery,
    protected readonly getSelfTimeInCallsScoreGoalQuery: GetSelfTimeInCallsScoreGoalQuery,
    protected readonly getSelfTimeInMeetingsScoreGoalQuery: GetSelfTimeInMeetingsScoreGoalQuery,
    protected readonly presenter: GetSelfGoalSummaryPresenter
  ) {}

  async get(
    props: GetSelfGoalSummariesRequestDto
  ): Promise<GetSelfGoalSummariesResponseDto> {
    try {
      const goals: GoalDto[] = props.goals;
      const queryPromises = goals.map((dto) => {
        const goalSummaryDto = {
          goal: dto,
          config: props.config,
        };
        if (dto.scoreName === CoreScoreNames.Screentime) {
          return this.getSelfScreentimeScoreGoalQuery.execute(goalSummaryDto);
        }
        if (dto.scoreName === CoreScoreNames['Digital Intensity']) {
          return this.getSelfDigitalIntensityScoreGoalQuery.execute(
            goalSummaryDto
          );
        }
        if (dto.scoreName === CoreScoreNames['Time in Meetings']) {
          return this.getSelfTimeInMeetingsScoreGoalQuery.execute(
            goalSummaryDto
          );
        }
        if (dto.scoreName === CoreScoreNames.Focus) {
          return this.getSelfFocusScoreGoalQuery.execute(goalSummaryDto);
        }
        if (dto.scoreName === CoreScoreNames['Digital Working hours']) {
          return this.getSelfDigitalWorkingHoursScoreGoalQuery.execute(
            goalSummaryDto
          );
        }
        if (dto.scoreName === CoreScoreNames['Time in Calls']) {
          return this.getSelfTimeInCallsScoreGoalQuery.execute(goalSummaryDto);
        }
        if (dto.measure === AppGoalsCubeMetric.TimeInApp) {
          return this.getSelfTimeInAppGoalQuery.execute(goalSummaryDto);
        }
        if (dto.measure === AppGoalsCubeMetric.Interactions) {
          return this.getSelfInteractionsGoalQuery.execute(goalSummaryDto);
        }
        if (dto.measure === AppGoalsCubeMetric.CallTimeInApp) {
          return this.getSelfCallTimeInAppGoalQuery.execute(goalSummaryDto);
        }
        if (dto.measure === AppGoalsCubeMetric.CalendarTimeInApp) {
          return this.getSelfCalendarTimeInAppGoalQuery.execute(goalSummaryDto);
        }
      });

      const result = await Promise.all(queryPromises);
      const mappedResult = result.map((entity) => {
        return this.presenter.toResponse(entity);
      });
      return { goals: mappedResult };
    } catch (error) {
      throw new Error(
        `GetSelfGoalSummaryCompositeController.get encountered an error ${error}`
      );
    }
  }
}
